import App from './../app.jsx'
import PagesError from './../pages/pages/error.js'
import PagesRegister from '../pages/auth/register.js'
import { Navigate } from 'react-router-dom'
import Dashboard from '../pages/dashboard/dashboard.js'
import GeneralAnalytics from '../pages/dashboard/generalAnalytics.js'
import CampaignsAnalytics from '../pages/campaigns/campaignsAnalytics.js'
import AppStore from '../pages/apps/appStore.js'
import AppNames from '../pages/apps/appNames.js'
import AppData from '../pages/apps/appData.js'
import AppDataInfo from '../pages/apps/appDataInfo.js'
import CustomerDashboard from '../pages/customers/customerDashboard.js'
import CustomerInfo from '../pages/customers/customerInfo.js'
import CustomerTickets from '../pages/customers/customerTickets.js'
import CampaignsInfo from '../pages/campaigns/campaignsInfo.js'
import CampaignsLoa from '../pages/campaigns/campaignsLoa.js'
import CampaignsTypes from '../pages/campaigns/campaignsTypes.js'
import CampaignsKeywords from '../pages/campaigns/campaignsKeywords.js'
import CampaignsSearchEngineKeywords from '../pages/campaigns/campaignsSearchEngineKeywords.js'
import DomainsInfo from '../pages/domains/domainsInfo.js'
import DomainsCategories from '../pages/domains/domainsCategories.js'
import IframeIgnoreDomains from '../pages/domains/iframeIgnoreDomains.js'
import BulkUpdateReprtingMethod from '../pages/domains/bulkUpdateReprtingMethod.js'
import BulkDomainsInsertion from '../pages/domains/bulkDomainsInsertion.js'
import VrdMessages from '../pages/domains/vrdMessages.js'
import GoogleInsertion from '../pages/linkInsertion/googleInsertion.js'
import BingInsertion from '../pages/linkInsertion/bingInsertion.js'
import TubesInsertion from '../pages/linkInsertion/tubesInsertion.js'
import CyberlockerInsertion from '../pages/linkInsertion/cyberlockerInsertion.js'
import TelegramInsertion from '../pages/linkInsertion/telegramInsertion.js'
import CyberlockerMarking from '../pages/LinkMarking/cyberlockerMarking.js'
import TelegramMarking from '../pages/LinkMarking/telegramMarking.js'
import TubesMarking from '../pages/LinkMarking/tubesMarking.js'
import UgcEpisodeMarking from '../pages/LinkMarking/ugcEpisodeMarking.js'
import GoogleMarking from '../pages/LinkMarking/googleMarking.js'
import BingMarking from '../pages/LinkMarking/bingMarking.js'
import ChangeLinksStatus from '../pages/LinkUpdate/changeLinksStatus.js'
import ChangeLinksCampaign from '../pages/LinkUpdate/changeLinksCampaign.js'
import ChangeRemovalStatus from '../pages/LinkUpdate/changeRemovalStatus.js'
import GetLinksDetails from '../pages/inquiries/getLinksDetails.js'
import ServicesInfo from '../pages/services/servicesInfo.js'
import ServicesCategories from '../pages/services/servicesCategories.js'
import IpAddress from '../pages/ipIspInfo/ipAddress.js'
import Isp from '../pages/ipIspInfo/isp.js'
import IptvInfo from '../pages/iptvStbsApps/iptvInfo.js'
import IptvPiracy from '../pages/iptvStbsApps/iptvPiracy.js'
import IptvTechnicalReports from '../pages/iptvStbsApps/iptvTechnicalReports.js'
import M3uFiles from '../pages/liveStreaming/m3uFiles.js'
import M3uKeywords from '../pages/liveStreaming/m3uKeywords.js'
import M3uResponseMessages from '../pages/liveStreaming/m3uResponseMessages.js'
import TubeReviewing from '../pages/reviewingScreenshots/tubeReviewing.js'
import TelegramReviewing from '../pages/reviewingScreenshots/telegramReviewing.js'
import SearchEngineReviewing from '../pages/reviewingScreenshots/searchEngineReviewing.js'
import UgcSearchReviewing from '../pages/reviewingScreenshots/ugcSearchReviewing.js'
import UgcSeasonReviewing from '../pages/reviewingScreenshots/ugcSeasonReviewing.js'
import UgcEpisodeReviewing from '../pages/reviewingScreenshots/ugcEpisodeReviewing.js'
import UgcSourceReviewing from '../pages/reviewingScreenshots/ugcSourceReviewing.js'
import LiveStreamingReviewing from '../pages/reviewingScreenshots/liveStreamingReviewing.js'
import TubesWhitelisting from '../pages/whitelist/tubesWhitelisting.js'
import DistributionTasks from '../pages/opsTaskManagement/distributionTasks.js'
import OpsPerformance from '../pages/opsTaskManagement/opsPerformance.js'
import Users from '../pages/auth/Users.js'
import CustomerUsers from '../pages/auth/customerUsers.js'
import Permissions from '../pages/auth/Permissions.js'
import Groups from '../pages/auth/groups.js'
import GenerateReports from '../pages/GenerateReports/GenerateReports.js'
import Login from '../pages/auth/login.js'
import Settings from '../pages/auth/settings.js'
import Profile from '../pages/auth/profile.js'
import CampaignInfoEdit from '../pages/campaigns/campaignInfoEdit.js'
import DomainInfoEditPage from '../pages/domains/domainInfoEditPage.js'
import BulkDomainsUpdate from '../pages/domains/bulkDomainsUpdate.js'
import IptvDataInfo from '../pages/iptvStbsApps/iptvDataInfo.js'
import IptvPiracyInfo from '../pages/iptvStbsApps/iptvPiracyInfo.js'
import ForgotPassword from '../pages/auth/forgotPassword.js'
import TubeCampaignReview from '../pages/reviewingScreenshots/campaignsReviewPages/tubeCampaignReview.js'
import SearchEngineCampaignReview from '../pages/reviewingScreenshots/campaignsReviewPages/searchEngineCampaignReview.js'
import UgcSearchCampaignsByDomain from '../pages/reviewingScreenshots/campaignsReviewPages/ugc/search/ugcSearchCampaignsByDomain.js'
import UgcSearchCampaignsByDomainReview from '../pages/reviewingScreenshots/campaignsReviewPages/ugc/search/ugcSearchCampaignsByDomainReview.js'
import UgcEpisodeCampaignsByDomain from '../pages/reviewingScreenshots/campaignsReviewPages/ugc/episode/ugcEpisodeCampaignsByDomain.js'
import UgcEpisodeCampaignsByDomainReview from '../pages/reviewingScreenshots/campaignsReviewPages/ugc/episode/ugcEpisodeCampaignsByDomainReview.js'
import UgcSeasonCampaignsByDomain from '../pages/reviewingScreenshots/campaignsReviewPages/ugc/season/ugcSeasonCampaignsByDomain.js'
import UgcSeasonCampaignsByDomainReview from '../pages/reviewingScreenshots/campaignsReviewPages/ugc/season/ugcSeasonCampaignsByDomainReview.js'
import UgcSourceCampaignsByDomain from '../pages/reviewingScreenshots/campaignsReviewPages/ugc/sourcs/ugcSourceCampaignsByDomain.js'
import UgcSourceCampaignsByDomainReview from '../pages/reviewingScreenshots/campaignsReviewPages/ugc/sourcs/ugcSourceCampaignsByDomainReview.js'
import LiveStreamingCampaignByCustomer from '../pages/reviewingScreenshots/liveStreaming/liveStreamingCampaignByCustomer.js'
import BlockingDomains from '../pages/blockingDomains/blockingDomains.js'
import BlockingDomainCategory from '../pages/blockingDomains/blockingDomainCategory.js'
import BlockingDomainActivity from '../pages/blockingDomains/blockingDomainActivity.js'
import CampaignDetails from '../pages/campaigns/campaignDetails.js'
import ResetPassword from '../pages/auth/resetPassword.js'
import TelegramCampaignReview from '../pages/reviewingScreenshots/campaignsReviewPages/telegramCampaignReview.js'
import NoPermission from '../pages/pages/noPermission.js'
import { can } from '../helpers/auth.js'
import RDPServers from '../pages/RdpServers/RDPServers.js'
import RDPViewer from '../pages/RdpServers/RDPViewer.js'
import IptvAnalytics from '../pages/iptvAnalytics/iptvAnalytics.js'
import LiveStreamingAnalytics from '../pages/liveStreamingAnalytics/liveStreamingAnalytics.js'
import CollectorSchedule from '../pages/periodicTasks/collectorSchedule.js'

function PermissionRoute({ permission, element }) {
  return [].concat(permission).some(p => can(p)) ? element : <NoPermission />
}

export const AppRoute = [
  {
    path: '*',
    element: <App />,
    children: [
      { path: '', element: <Navigate to={'/dashboard'} /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'general-analytics', element: <GeneralAnalytics /> },
      { path: 'campaigns-analytics', element: <CampaignsAnalytics /> },
      {path: 'iptv-analytics', element: <IptvAnalytics />},
      { path: 'live-streaming-analytics', element: <LiveStreamingAnalytics /> },
      { path: 'campaigns-analytics/:id', element: <CampaignDetails /> },

      { path: 'periodic-tasks', element: <PermissionRoute permission={['django_celery_beat.view_periodictask', 'view_periodictask']} element={<CollectorSchedule />} /> },

      { path: 'customer-dashboard', element: <CustomerDashboard /> },
      {
        path: 'customers/*',
        children: [
          { path: 'customers-info', element: <PermissionRoute permission="get_customers" element={<CustomerInfo />} /> },
          { path: 'customers-tickets', element: <PermissionRoute permission="view_customerticket" element={<CustomerTickets />} /> },
        ]
      },
      {
        path: 'campaigns/*',
        children: [
          { path: 'campaigns-info', element: <PermissionRoute permission="get_campaigns" element={<CampaignsInfo />} /> },
          { path: 'campaigns-info/:id', element: <PermissionRoute permission="get_campaigns" element={<CampaignInfoEdit />} /> },
          { path: 'campaigns-loa', element: <PermissionRoute permission="view_campaign_loa" element={<CampaignsLoa />} /> },
          { path: 'campaigns-types', element: <PermissionRoute permission="view_campaigntype" element={<CampaignsTypes />} /> },
          { path: 'campaigns-keywords', element: <PermissionRoute permission="view_campaignkeyword" element={<CampaignsKeywords />} /> },
          {
            path: 'campaigns-search-engine-keywords',
            element: <PermissionRoute permission="view_search_engine_keywords_campaign" element={<CampaignsSearchEngineKeywords />} />
          }
        ]
      },
      {
        path: 'domains/*',
        children: [
          { path: 'domains-info', element: <PermissionRoute permission="get_domains" element={<DomainsInfo />} /> },
          { path: 'domains-info/:id/:tab', element: <PermissionRoute permission="get_domains" element={<DomainInfoEditPage />} /> },
          { path: 'domains-categories', element: <PermissionRoute permission="view_domaincategory" element={<DomainsCategories />} /> },
          { path: 'iframe-ignore-domains', element: <PermissionRoute permission="view_ignoredomain" element={<IframeIgnoreDomains />} /> },
          { path: 'bulk-domains-insertion', element: <PermissionRoute permission="add_Domains_Bulk_Insertion" element={<BulkDomainsInsertion />} /> },
          { path: 'bulk-domains-update', element: <PermissionRoute permission="add_Domains_Bulk_Update" element={<BulkDomainsUpdate />} /> },
          {
            path: 'bulk-update-reporting-method',
            element: <PermissionRoute permission="add_Domain_Reporting_Method_Bulk_Update" element={<BulkUpdateReprtingMethod />} />
          },
          { path: 'vrd-messages', element: <PermissionRoute permission="view_vrdmessage" element={<VrdMessages />} /> }
        ]
      },
      {
        path: 'blocking/*',
        children: [
          { path: 'blocking-domains', element: <PermissionRoute permission="view_blockingdomain" element={<BlockingDomains />} /> },
          { path: 'blocking-domain-category', element: <PermissionRoute permission="view_blockingdomaincategory" element={<BlockingDomainCategory />} /> },
          { path: 'blocking-domain-activity', element: <PermissionRoute permission="view_blockingdomainactivity" element={<BlockingDomainActivity />} /> },
        ]
      },
      {
        path: 'link-insertion/*',
        children: [
          { path: 'google', element: <PermissionRoute permission="add_Links_Insertion" element={<GoogleInsertion />} /> },
          { path: 'bing', element: <PermissionRoute permission="add_Links_Insertion" element={<BingInsertion />} /> },
          { path: 'tubes', element: <PermissionRoute permission="add_Links_Insertion" element={<TubesInsertion />} /> },
          { path: 'cyberlocker', element: <PermissionRoute permission="add_Links_Insertion" element={<CyberlockerInsertion />} /> },
          { path: 'telegram', element: <PermissionRoute permission="add_Links_Insertion" element={<TelegramInsertion />} /> },
        ]
      },
      {
        path: 'link-marking/*',
        children: [
          { path: 'google', element: <PermissionRoute permission="mark_Links_Insertion" element={<GoogleMarking />} /> },
          { path: 'bing', element: <PermissionRoute permission="mark_Links_Insertion" element={<BingMarking />} /> },
          { path: 'tubes', element: <PermissionRoute permission="mark_Links_Insertion" element={<TubesMarking />} /> },
          { path: 'cyberlocker', element: <PermissionRoute permission="mark_Links_Insertion" element={<CyberlockerMarking />} /> },
          { path: 'telegram', element: <PermissionRoute permission="mark_Links_Insertion" element={<TelegramMarking />} /> },
          { path: 'ugc-episode', element: <PermissionRoute permission="mark_Links_Insertion" element={<UgcEpisodeMarking />} /> },
        ]
      },
      {
        path: 'update-links/*',
        children: [
          { path: 'change-links-status', element: <PermissionRoute permission="update_Links_Insertion" element={<ChangeLinksStatus />} /> },
          { path: 'change-links-campaign', element: <PermissionRoute permission="update_Links_Insertion" element={<ChangeLinksCampaign />} /> },
          { path: 'change-removal-status', element: <PermissionRoute permission="update_Links_Insertion" element={<ChangeRemovalStatus />} /> }
        ]
      },
      {
        path: 'inquiries/*',
        children: [{ path: 'get-links-details', element: <PermissionRoute permission="view_links_info" element={<GetLinksDetails />} /> }]
      },
      {
        path: 'services/*',
        children: [
          { path: 'services-info', element: <PermissionRoute permission="view_service" element={<ServicesInfo />} /> },
          { path: 'services-categories', element: <PermissionRoute permission="view_servicecategory" element={<ServicesCategories />} /> }
        ]
      },
      {
        path: 'ip-isp/*',
        children: [
          { path: 'ip-address', element: <PermissionRoute permission="view_ipaddress" element={<IpAddress />} /> },
          { path: 'isp', element: <PermissionRoute permission="view_isp" element={<Isp />} /> }
        ]
      },
      {
        path: 'apps/*',
        children: [
          { path: 'stores', element: <PermissionRoute permission="view_appstore" element={<AppStore />} /> },
          { path: 'names', element: <PermissionRoute permission="view_appname" element={<AppNames />} /> },
          { path: 'data', element: <PermissionRoute permission="view_appstoredata" element={<AppData />} /> },
          { path: 'data/:id', element: <PermissionRoute permission="view_appstoredata" element={<AppDataInfo />} /> }
        ]
      },
      {
        path: 'iptv/*',
        children: [
          { path: 'iptv-information/:id', element: <PermissionRoute permission="view_iptv" element={<IptvDataInfo />} /> },
          { path: 'iptv-information', element: <PermissionRoute permission="view_iptv" element={<IptvInfo />} /> },
          { path: 'iptv-piracy-servers-information', element: <PermissionRoute permission="view_iptvserver" element={<IptvPiracy />} /> },
          {
            path: 'iptv-piracy-servers-information/:id',
            element: <PermissionRoute permission="view_iptvserver" element={<IptvPiracyInfo />} />
          },
          { path: 'iptv-technical-reports', element: <PermissionRoute permission="view_iptvtechnicalreports" element={<IptvTechnicalReports />} /> }
        ]
      },
      {
        path: 'live-streaming/*',
        children: [
          { path: 'm3u-files', element: <PermissionRoute permission="view_m3ufiles" element={<M3uFiles />} /> },
          { path: 'm3u-keywords', element: <PermissionRoute permission="view_m3ukeywords" element={<M3uKeywords />} /> },
          { path: 'm3u-response-messages', element: <PermissionRoute permission="view_m3uresponsemessages" element={<M3uResponseMessages />} /> }
        ]
      },
      {
        path: 'reviewing-screenshots/*',
        children: [
          { path: 'tube', element: <PermissionRoute permission="view_Review_Screenshot" element={<TubeReviewing />} /> },
          { path: 'dailymotion/campaign/:id/:service', element: <PermissionRoute permission="view_Review_Screenshot" element={<TubeCampaignReview />} /> },
          { path: 'vimeo/campaign/:id/:service', element: <PermissionRoute permission="view_Review_Screenshot" element={<TubeCampaignReview />} /> },
          { path: 'okru/campaign/:id/:service', element: <PermissionRoute permission="view_Review_Screenshot" element={<TubeCampaignReview />} /> },
          { path: 'telegram', element: <PermissionRoute permission="view_Review_Screenshot" element={<TelegramReviewing />} /> },
          { path: 'telegram/campaign/:id', element: <PermissionRoute permission="view_Review_Screenshot" element={<TelegramCampaignReview />} /> },
          { path: 'search-engine', element: <PermissionRoute permission="view_Review_Screenshot" element={<SearchEngineReviewing />} /> },
          { path: 'search-engine/campaign/:id', element: <PermissionRoute permission="view_Review_Screenshot" element={<SearchEngineCampaignReview />} /> },
          { path: 'ugc-search', element: <PermissionRoute permission="view_Review_Screenshot" element={<UgcSearchReviewing />} /> },
          { path: 'ugc-search/campaign/:id', element: <PermissionRoute permission="view_Review_Screenshot" element={<UgcSearchCampaignsByDomain />} /> },
          { path: 'ugc-search/campaign/:id/review/:domain', element: <PermissionRoute permission="view_Review_Screenshot" element={<UgcSearchCampaignsByDomainReview />} /> },
          { path: 'ugc-season', element: <PermissionRoute permission="view_Review_Screenshot" element={<UgcSeasonReviewing />} /> },
          { path: 'ugc-season/campaign/:id', element: <PermissionRoute permission="view_Review_Screenshot" element={<UgcSeasonCampaignsByDomain />} /> },
          { path: 'ugc-season/campaign/:id/review/:domain', element: <PermissionRoute permission="view_Review_Screenshot" element={<UgcSeasonCampaignsByDomainReview />} /> },
          { path: 'ugc-episode', element: <PermissionRoute permission="view_Review_Screenshot" element={<UgcEpisodeReviewing />} /> },
          { path: 'ugc-episode/campaign/:id', element: <PermissionRoute permission="view_Review_Screenshot" element={<UgcEpisodeCampaignsByDomain />} /> },
          { path: 'ugc-episode/campaign/:id/review/:domain', element: <PermissionRoute permission="view_Review_Screenshot" element={<UgcEpisodeCampaignsByDomainReview />} /> },
          { path: 'ugc-source', element: <PermissionRoute permission="view_Review_Screenshot" element={<UgcSourceReviewing />} /> },
          { path: 'ugc-source/campaign/:id', element: <PermissionRoute permission="view_Review_Screenshot" element={<UgcSourceCampaignsByDomain />} /> },
          { path: 'ugc-source/campaign/:id/review/:domain', element: <PermissionRoute permission="view_Review_Screenshot" element={<UgcSourceCampaignsByDomainReview />} /> },
          { path: 'live-streaming', element: <PermissionRoute permission="view_Review_Screenshot" element={<LiveStreamingReviewing />} /> },
          { path: 'live-streaming/customer/:id/', element: <PermissionRoute permission="view_Review_Screenshot" element={<LiveStreamingCampaignByCustomer />} /> },
        ]
      },
      {
        path: 'whitelist-channels/*',
        children: [
          {
            path: 'tubes-whitelisting-channels',
            element: <PermissionRoute permission="view_Tubes_Whitelisting_Channels" element={<TubesWhitelisting />} />
          }
        ]
      },
      {
        path: 'ops-tasks-management/*',
        children: [
          { path: 'distribution-tasks', element: <PermissionRoute permission="get_task_distribution" element={<DistributionTasks />} /> },
          { path: 'ops-performance', element: <PermissionRoute permission="view_Reviewing_Performance_ops" element={<OpsPerformance />} /> },
        ]
      },
      {
        path: 'auth/*',
        children: [
          { path: 'users', element: <PermissionRoute permission="view_user" element={<Users />} /> },
          { path: 'customer-users', element: <PermissionRoute permission="view_Customer_Users" element={<CustomerUsers />} /> },
          { path: 'permissions', element: <PermissionRoute permission="view_permission" element={<Permissions />} /> },
          { path: 'groups', element: <PermissionRoute permission="view_group" element={<Groups />} /> }
        ]
      },
      {
        path: 'rdp-servers/*',
        children: [
          { path: '', element: <PermissionRoute permission="add_guacamole_session" element={<RDPServers />} /> },
          { path: ':connectionId', element: <PermissionRoute permission="add_guacamole_session" element={<RDPViewer />} /> },
        ]
      },
      { path: 'generate-reports', element: <PermissionRoute permission="Generate_Report" element={<GenerateReports />} /> },
      { path: 'login', element: <Login /> },
      { path: 'register', element: <PagesRegister /> },
      { path: 'forgot-password', element: <ForgotPassword /> },
      { path: 'reset-password/:token', element: <ResetPassword /> },
      { path: 'profile', element: <Profile />, protected: true },
      { path: 'settings', element: <Settings />, protected: true },
      { path: '*', element: <PagesError /> }
    ]
  }
]
